import { StorageKeys } from '../types/api';

export class StorageService {
  private static instance: StorageService;

  static getInstance(): StorageService {
    if (!StorageService.instance) {
      StorageService.instance = new StorageService();
    }
    return StorageService.instance;
  }

  // Get item from localStorage with JSON parsing
  getItem<T>(key: StorageKeys | string): T | null {
    try {
      const item = localStorage.getItem(key);
      if (!item) return null;
      return JSON.parse(item);
    } catch (error) {
      console.error(`Error getting item from storage: ${key}`, error);
      return null;
    }
  }

  // Set item in localStorage with JSON stringifying
  setItem(key: StorageKeys | string, value: any): boolean {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error(`Error setting item in storage: ${key}`, error);
      return false;
    }
  }

  // Remove item from localStorage
  removeItem(key: StorageKeys | string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item from storage: ${key}`, error);
    }
  }

  // Check if item exists
  hasItem(key: StorageKeys | string): boolean {
    return localStorage.getItem(key) !== null;
  }

  // Clear all app-related storage
  clearAppStorage(): void {
    Object.values(StorageKeys).forEach(key => {
      this.removeItem(key);
    });
  }

  // Get storage info
  getStorageInfo(): { used: number; available: number } {
    let used = 0;
    try {
      for (let key in localStorage) {
        if (localStorage.hasOwnProperty(key)) {
          used += localStorage[key].length + key.length;
        }
      }
    } catch (error) {
      console.error('Error calculating storage usage', error);
    }
    
    return {
      used,
      available: 5 * 1024 * 1024 - used // Approximate 5MB limit
    };
  }
}